import type { CSSProperties } from "react";
import classNames from "components/ui/classNames";
import { mineShaft } from "../palette";
import type { ITooltipProps } from "./Tooltip";
import Tooltip from "./Tooltip";

interface ITextTooltipProps extends Omit<ITooltipProps, "render"> {
  content: string | (() => string);
  className?: string;
  style?: CSSProperties;
}

export default function TextTooltip({ content, className, style, ...props }: ITextTooltipProps) {
  return (
    <Tooltip
      {...props}
      backgroundColor={mineShaft}
      arrowColor={mineShaft}
      render={() => (
        <div
          className={classNames(
            "flex rounded bg-[#333333] px-2 py-1 text-sm font-medium tracking-wider text-white",
            className,
          )}
          style={style}
        >
          {typeof content === "string" ? content : content()}
        </div>
      )}
    />
  );
}
